module.exports = __webpack_public_path__ + "assets/img/18_1711.d873ad33.jpg";